import { sidebarModeFor } from "./navigation";

/* Where "Back to app" leads: the last page outside Settings in this tab.
 * A module copy answers within a page load; sessionStorage carries it across
 * a reload inside Settings, and may be missing or throw (private windows,
 * blocked site data). A deep link into Settings falls back to the agent list. */
const SETTINGS_RETURN_KEY = "forgedock.settings-return";
export const SETTINGS_RETURN_FALLBACK = "/agents";

let remembered: string | null = null;

/** Records `location` (path, query and hash) unless it is a settings page. */
export function rememberAppLocation(location: string): void {
	if (sidebarModeFor(location.split(/[?#]/, 1)[0]) === "settings") return;
	remembered = location;
	try {
		window.sessionStorage.setItem(SETTINGS_RETURN_KEY, location);
	} catch {
		// The module copy still covers this page load.
	}
}

export function getSettingsReturnTo(): string {
	if (remembered) return remembered;
	try {
		return window.sessionStorage.getItem(SETTINGS_RETURN_KEY) || SETTINGS_RETURN_FALLBACK;
	} catch {
		return SETTINGS_RETURN_FALLBACK;
	}
}
